import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./MenuModal.module.css";
import {
  availableDishesActions,
  menuMenuActions,
} from "../../../../store/slices/menu-slices";
import MenuSingleItemModal from "../MenuSingleItemModal/MenuSingleItemModal";
import { SearchMenuInputModal } from "../SearchMenuInputModal/SearchMenuInputModal";

const MenuModal = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const {
    availableDishesArray,
    trigger,
    dataOfDay,
    availableDishesArrayFiltered,
  } = useSelector((store) => store.availableDishes);

  useEffect(() => {
    if (dataOfDay) {
      dispatch(
        availableDishesActions.getAllAvailableDishes({ currentData: dataOfDay })
      );
    }
  }, [dataOfDay, trigger, dispatch]);

  const dishesToRender =
    availableDishesArrayFiltered?.length > 0
      ? availableDishesArrayFiltered
      : availableDishesArray;

  const closeMenuModal = () => {
    dispatch(menuMenuActions.changeIdMatching(""));
    setIsOpen(false);
  };

  return (
    <div className={css.overlay}>
      <div className={css.modal}>
        <div className={css.header}>
          <h2>Select dish</h2>
          <button className={css.closeButton} onClick={closeMenuModal}>
            &times;
          </button>
        </div>

        <div className={css.blockInput}>
          <SearchMenuInputModal />
        </div>

        <div className={css.table}>
          <div className={css.tableHeader}>
            <div className={css.tableHeaderImage}>Image</div>
            <div className={css.tableHeaderName}>Name</div>
            <div className={css.tableHeaderCat}>Category</div>
            <div className={css.tableHeaderWeight}>Weight</div>
            <div className={css.tableHeaderWeightNetto}>Weight Netto</div>
            <div className={css.tableHeaderCost}>Cost</div>
            <div className={css.tableHeaderPrice}>Price</div>
          </div>

          <div className={css.tableBody}>
            {dishesToRender.map((obj) => (
              <MenuSingleItemModal
                key={obj.id}
                dish={obj}
                setIsOpen={setIsOpen}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuModal;
